import Axios from 'axios'

function getItemToPush(item) {
  return {
    id: item.item_id,
    item_id: item.item_id,
    item_name: item.item_name,
    item_brand: item.item_brand,
    item_category: item.item_category,
    item_category_2: item.item_category_2,
    item_category_3: item.item_category_3,
    item_category_4: item.item_category_4,
    item_variant: item.item_variant,
    item_flavor: item.item_flavor,
    item_color: item.item_color,
    item_size: item.item_size,
    index: item.index,
    quantity: item.quantity,
    price: item.price,
    google_business_vertical: 'retail',
  }
}

/**
 * slider click on slide beküldés
 *
 * @param promotionData
 */
window.dataLayerClickSlidePromotion = function (promotionData) {}

/**
 * slider aktuális slide data beküldés
 *
 * @param promotionData
 */
window.dataLayerViewSlidePromotion = function (promotionData) {}

/**
 * item click ga4 datalayer push & ga3 ga(send)
 *
 * @param item
 */
window.dataLayerSelectItem = function (item) {
  console.log('window.dataLayerSelectItem: ' + (window.isGtmEnabled ? 'ON' : 'GTM OFF'))

  if (!window.isGtmEnabled) {
    return
  }

  item.quantity = 1
  const itemToPush = getItemToPush(item)

  /* GTM GA4 */
  dataLayer.push({
    event: 'select_item',
    ecommerce: {
      items: [
        itemToPush,
      ],
    },
  })
}

/**
 * item add to cart ga4 datalayer push & ga3 ga(send)
 *
 * @param item
 */
window.dataLayerAddItemToCart = function (item) {
  console.log('window.dataLayerAddItemToCart: ' + (window.isGtmEnabled ? 'ON' : 'GTM OFF'))

  if (typeof fbq === 'function') {
    fbq('track', 'AddToCart', {
      content_name: item.item_name,
      content_category: item.item_category ? (item.item_category + '/' + item.item_category_2 + '/' + item.item_category_3) : '',
      content_ids: [item.item_id],
      content_type: 'product',
      value: item.price,
      currency: DOMAIN_CURRENCY,
    },
    {
      eventID: item.cart_record_id,
    })
  }

  /* if (typeof ttq === 'object') {
    ttq.track('AddToCart', {
      contents: [
        {
          content_id: item.item_id,
          content_name: item.item_name,
          content_category: item.item_category ? (item.item_category + '/' + item.item_category_2 + '/' + item.item_category_3) : '',
          quantity: 1,
          price: item.price
        }],
      content_type: 'product',
      value: item.price,
      currency: DOMAIN_CURRENCY,
    },
    {
      event_id: item.cart_record_id,
    })
  } */

  if (!window.isGtmEnabled) {
    return
  }

  const itemToPush = getItemToPush(item)

  /* GTM GA4 */
  dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object. ?
  dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: DOMAIN_CURRENCY,
      value: item.price * item.quantity,
      items: [
        itemToPush,
      ],
    },
  })

  /* Klaviyo Added to Cart */
  // Klaviyo, ha nincs bekapcsolva ezen a domainen akkor RETURN
  if (!window.isKlaviyoEnabled) {
    return
  }

  // Klaviyo Added to cart eseményhez adatok összeállítása és meghívása
  if (typeof klaviyo !== 'undefined') {
    Axios.get('/Shop/api/getCartDataForKlaviyo?addedCartRecordId=' + item.cart_record_id)
      .then(({ data }) => {
        klaviyo.track('Added to Cart', data)
      })
      .catch((error) => {
        console.error(error)
      })
  } else {
    console.log('Klaviyo is not defined')
  }
}

/**
 * item remove from cart ga4 datalayer push & ga3 ga(send)
 *
 * @param item
 */
window.dataLayerRemoveItemFromCart = function (item) {
  console.log('window.dataLayerRemoveItemFromCart: ' + (window.isGtmEnabled ? 'ON' : 'GTM OFF'))

  if (!window.isGtmEnabled) {
    return
  }

  const itemToPush = getItemToPush(item)

  /* GTM GA4 */
  dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object. ?
  dataLayer.push({
    event: 'remove_from_cart',
    ecommerce: {
      currency: DOMAIN_CURRENCY,
      value: item.price,
      items: [
        itemToPush,
      ],
    },
  })
}

/**
 * pageView event beküldése
 */
window.dataLayerViewPage = function () {
  if (!window.isGtmEnabled) {
    return
  }
  dataLayer.push({
    event: 'pageview',
    page: {
      path: location.pathname + location.search,
      title: document.title,
      location: location.href,
    },
  })
}

/**
 * item view on item page ga4 datalayer push & ga3 ga(send)
 *
 * @param item
 */
window.dataLayerViewItem = function (item) {
  console.log('window.dataLayerViewItem: ' + (window.isGtmEnabled ? 'ON' : 'GTM OFF'))

  if (!window.isGtmEnabled) {
    return
  }

  console.log(item)

  item.quantity = 1
  const itemToPush = getItemToPush(item)

  /* GTM GA4 */
  dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object. ?
  dataLayer.push({
    event: 'view_item',
    ecommerce: {
      currency: DOMAIN_CURRENCY,
      value: item.price,
      items: [
        itemToPush,
      ],
    },
  })

  /* Klaviyo Viewed Product */
  // Klaviyo, ha nincs bekapcsolva ezen a domainen akkor RETURN
  if (!window.isKlaviyoEnabled) {
    return
  }

  // Klaviyo Added to cart eseményhez adatok összeállítása és meghívása
  if (typeof klaviyo !== 'undefined') {
    Axios.get('/Shop/api/getViewedProductDataForKlaviyo?ifs_cikkszam=' + item.item_id)
      .then(({ data }) => {
        klaviyo.track('Viewed Product', data)
      })
      .catch((error) => {
        console.error(error)
      })
  } else {
    console.log('Klaviyo is not defined')
  }
}

/**
 * checkout begin ga4 datalayer push
 *
 * @param items
 */
window.dataLayerCheckout = function (items) {
  console.log('window.dataLayerCheckout: ' + (window.isGtmEnabled ? 'ON' : 'GTM OFF'))

  if (!window.isGtmEnabled) {
    return
  }

  console.log(items)

  let totalValue = 0.0
  for (let i = 0; i < items.length; i++) {
    totalValue += items[i].price * items[i].quantity
  }

  /* GTM GA4 */
  dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object. ?
  dataLayer.push({
    event: 'begin_checkout',
    ecommerce: {
      currency: DOMAIN_CURRENCY,
      value: totalValue,
      items: items,
    },
  })

  /* Klaviyo Started Checkout */
  // Klaviyo, ha nincs bekapcsolva ezen a domainen akkor RETURN
  if (!window.isKlaviyoEnabled) {
    return
  }

  // Klaviyo Added to cart eseményhez adatok összeállítása és meghívása
  if (typeof klaviyo !== 'undefined') {
    Axios.get('/Shop/api/getCheckoutDataForKlaviyo')
      .then(({ data }) => {
        klaviyo.track('Started Checkout', data)
      })
      .catch((error) => {
        console.error(error)
      })
  } else {
    console.log('Klaviyo is not defined')
  }
}

/**
 * item-list view ga4 datalayer push
 *
 * @param items
 * @param itemListId
 * @param itemListName
 */
window.dataLayerViewItemList = function (items, itemListId, itemListName) {
  console.log('window.dataLayerViewItemList: ' + (window.isGtmEnabled ? itemListId + ' - ' + itemListName : 'GTM OFF'))

  if (!window.isGtmEnabled) {
    return
  }

  console.log(items)

  /* GTM GA4 */
  /* Old GA4 view_item_list push without item_list_id & item_list_name */
  dataLayer.push({
    event: 'view_item_list',
    ecommerce: {
      items: items,
    },
  })
}

window.dataLayerCheckoutSuccess = function (purchase) {
  console.log('window.dataLayerCheckoutSuccess')

  /* Google Ads Conversion */
  dataLayer.push({
    event: 'purchase_event',
    google_conversion_id: purchase.googleConversionId,
    google_conversion_label: purchase.googleConversionLabel,
    google_conversion_value: purchase.value,
    google_conversion_transaction_id: purchase.transaction_id,
    google_conversion_currency: purchase.currency,
    google_conversion_email: purchase.email,
    google_conversion_phone: purchase.phone,
  })
  delete purchase.googleConversionId
  delete purchase.googleConversionLabel

  /* Facebook Conversion */
  if (typeof fbq !== 'undefined') {
    const fbqItems = []
    purchase.items.map((item) => {
      fbqItems.push({
        id: item.item_id,
        quantity: item.quantity,
        item_price: item.item_price,
      })
    })
    fbq('track', 'Purchase', {
      contents: fbqItems,
      content_type: 'product',
      value: purchase.value,
      currency: purchase.currency,
    },
    {
      eventID: purchase.transaction_id,
    })
  }

  /* TikTok purchase */
  /* if (typeof ttq === 'object') {
    ttq.track('PlaceAnOrder', {
      contents: purchase.items.map((item) => ({
          content_id: item.item_id,
          content_type: 'product',
          quantity: item.quantity,
          price: item.item_price,
        })
      ),
      content_type: 'product',
      value: purchase.value,
      currency: purchase.currency,
    },
    {
      event_id: purchase.transaction_id
    })
  } */

  /* Emarsys Purchase */
  if (typeof ScarabQueue !== 'undefined') {
    // The usual commands to identify visitors and report cart contents. Please note the empty cart values - remember to empty the cart on purchase.
    ScarabQueue.push(['setEmail', purchase.email])
    ScarabQueue.push(['cart', []])

    // Passing on order details. The price values passed on here serve as the basis of our revenue and revenue contribution reports.
    ScarabQueue.push(['purchase', {
      orderId: purchase.transaction_id,
      items: purchase.items.map((item) => ({
        item: item.item_id,
        price: item.item_price_huf,
        quantity: item.quantity,
      }),
      ),
    }])

    // Firing the ScarabQueue. Should be the last call on the page, called only once.
    ScarabQueue.push(['go'])
  }
}

/**
 * Google Ecommerce, GA4 purchase
 * thank_you pagen fut, rendelés után ga4 datalayer push
 *
 * @param purchase
 */
window.dataLayerPurchase = function (purchase) {
  console.log('window.dataLayerPurchase')
  if (!window.isGtmEnabled) {
    return
  }

  /* GTM GA4 */
  dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
  dataLayer.push({
    event: 'purchase',
    ecommerce: purchase,
  })
}

/**
 * Emarsys kód beszurása
 *
 * @param emarsys string
 */
window.addEmarsys = function (emarsys) {
  if (typeof ScarabQueue !== 'undefined' && emarsys !== '') {
    eval(emarsys)
  }
}

/**
 * Klaviyo JS kód beszúrása
 *
 * @param klaviyoJSTrackingCode string
 */
window.addKlaviyoJSTrackingCode = function (klaviyoJSTrackingCode) {
  if (klaviyoJSTrackingCode !== '') {
    eval(klaviyoJSTrackingCode)
  }
}

/**
 * category és brand google remarketing add
 *
 * @param remarketing {{
 *   category: String,
 *   brand: String,
 * }}
 */
window.addRemarketing = function (remarketing) {
  if ('category' in remarketing && remarketing.category !== '') {
    eval(remarketing.category)
  }
  if ('brand' in remarketing && remarketing.brand !== '') {
    eval(remarketing.brand)
  }
}

/**
 * Update Google Consent (update GTM consent settings)
 *
 * @param {String} adStorage (granted|denied)
 * @param {String} analyticsStorage (granted|denied)
 * @param {String} personalizationStorage (granted|denied)
 */
window.updateConsent = function (adStorage, analyticsStorage, personalizationStorage) {
  if (!window.isGtmEnabled) {
    return
  }
  dataLayer.push({
    event: 'consent_update',
    ad_storage: adStorage,
    ad_user_data: adStorage,
    analytics_storage: analyticsStorage,
    personalization_storage: personalizationStorage,
    ad_personalization: personalizationStorage,
  })
  console.log('Google Consent Update')

  // Call consent update after event
  setTimeout(function () {
    dataLayer.push({ event: 'consent_update_after' })
    console.log('Google Consent Update AFTER')
  }, 200)
}

window.setActiveUser = function (user) {
  if (typeof klaviyo !== 'undefined') {
    klaviyo.identify({
      email: user.email,
      first_name: user.firstName,
      last_name: user.lastName,
    }).then(() => console.log('Klaviyo identify has been completed: ' + user.email))
  } else {
    console.log('Klaviyo is not defined')
  }
}

window.registerUser = function (email, conversionId, conversionLabel) {
  if (!conversionId || !conversionLabel) {
    return
  }
  // Google Ads konverziós követés
  dataLayer.push({
    event: 'registration_event',
    google_conversion_id: conversionId,
    google_conversion_label: conversionLabel,
    google_conversion_email: email,
  })
  console.log('User registration event call: ' + email)
}
